import { SET_MATERIAL_BILLS } from "constants/productionConstants";

const initialState = {
  materialBills: [],
};

const productionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MATERIAL_BILLS:
      return {
        ...state,
        materialBills: action.materialBills,
      };

    default:
      return state;
  }
};

export default productionReducer;
